import React from 'react';

import moment from 'moment';

const LoanStatementDetails = ({ data, downloadStatement, onBack }) => {
  if (!data) {
    return null;
  }
  const rowData = [
    ['Statement ID', `#${data.statementRowId}`, data.statementRowId],
    ['Statement Date', moment(data.statementDate).format('MMMM D, YYYY'), data.statementDate],
    [
      'Payment Due Date',
      moment(data.statementDueDate).format('MMMM D, YYYY'),
      data.statementDueDate,
    ],
    [
      'Statement Balance',
      data.totalCurrentDueBalance.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      }),
      data.totalCurrentDueBalance,
    ],
    [
      'Payoff Balance',
      data.currentPayoffBalance.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      }),
      data.currentPayoffBalance,
    ],
  ].filter((item) => !!item[2]);

  return (
    <div className="StatementDetails">
      <div>
        <div className="StatementDetailsTitle">Statement Details</div>
        <div>
          <div className="table">
            {rowData.map(([label, value]) => (
              <div key={`row-${label}`} className="row tableRow">
                <div>
                  <div className="detailLabel">{label}</div>
                </div>
                <div>
                  <div className="detailValue">{value}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="row backLink">
            <div>
              <a href="#" onClick={onBack}>
                Back to Statements
              </a>
            </div>
            <div>
              <button className="btn primary-btn" onClick={downloadStatement}>
                Download PDF
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanStatementDetails;
